import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { ToolLoadingProps } from "./toolLoadingRegistry";

export const DefaultToolLoading: React.FC<ToolLoadingProps> = ({
  toolName,
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          p: 2,
          bgcolor: "grey.50",
          borderRadius: 1,
          border: "1px solid",
          borderColor: "grey.200",
        }}
      >
        <CircularProgress size={20} />
        <Typography variant="body2" color="text.secondary">
          Preparing {toolName}...
        </Typography>
      </Box>
    </Box>
  );
};